import type { StudentItem } from '../api/backend'
import { STUDENT_MASCOTS, STUDENT_SECRET_EMOJIS } from './robolabx-login-catalog'
import { parseStudentUsername } from './student-creation'

type StudentIdentityLike = {
  username?: string | null
  displayPassword?: string | null
  pictureSecretIds?: string[] | null
  pictureSecretEmojis?: string[] | null
  mascotId?: string | null
  mascotLabel?: string | null
  mascotEmoji?: string | null
  givenName?: string | null
  surName?: string | null
  name?: string | null
}

export function resolveStudentMascotDisplay(student: StudentIdentityLike) {
  const parsedUsername = parseStudentUsername(student.username)
  const mascot = student.mascotId
    ? STUDENT_MASCOTS.find((item) => item.id === student.mascotId)
    : parsedUsername.mascotId
      ? STUDENT_MASCOTS.find((item) => item.id === parsedUsername.mascotId)
      : null

  return {
    emoji: student.mascotEmoji ?? mascot?.emoji ?? '',
    label: student.mascotLabel ?? mascot?.label ?? '—',
  }
}

export function resolveStudentNameDisplay(student: Pick<StudentIdentityLike, 'givenName' | 'surName' | 'name'>) {
  const fullName = [student.givenName?.trim(), student.surName?.trim()].filter(Boolean).join(' ')
  return fullName || student.name?.trim() || '—'
}

export function resolveStudentUsernameDisplay(student: Pick<StudentIdentityLike, 'username'>) {
  const parsedUsername = parseStudentUsername(student.username)
  return parsedUsername.fullName ?? student.username?.trim() ?? '—'
}

export function resolveStudentDisplayPassword(student: Pick<StudentIdentityLike, 'displayPassword' | 'pictureSecretEmojis' | 'pictureSecretIds'>) {
  if (student.displayPassword?.trim()) {
    const normalized = student.displayPassword.trim()
    const rawTokens = normalized
      .split('|')
      .map((item) => item.trim())
      .filter(Boolean)
    const emojiTokens = rawTokens
      .map((secretId) => STUDENT_SECRET_EMOJIS.find((item) => item.id === secretId)?.emoji ?? null)
      .filter(Boolean)

    if (rawTokens.length > 0 && emojiTokens.length === rawTokens.length) {
      return emojiTokens.join(' ')
    }
  }

  const emojiPassword = student.pictureSecretEmojis
    ?.map((item) => item?.trim())
    .filter(Boolean)
    .join(' ')

  if (emojiPassword) {
    return emojiPassword
  }

  const secretIdPassword = student.pictureSecretIds
    ?.map((item) => item?.trim())
    .filter(Boolean)
    .map((secretId) => STUDENT_SECRET_EMOJIS.find((item) => item.id === secretId)?.emoji ?? null)
    .filter(Boolean)
    .join(' ')

  return emojiPassword || secretIdPassword || '-'
}

export type { StudentItem }
